/**
 * Grid alignment Script
 */
{
  window.setGridHeight = (selector) => {
    let gridOffsets = [];
    let gridRowOffsets = []

    gridOffsets = Array.from(document.querySelectorAll(selector)).map((element,index) => {
      let grid = element.closest('product-card') || element.closest('[data-equal]') || element.closest('.predictive-search-results__card') || element.closest('.featured-blog-posts-card__inner') || element.closest('.js-card-height');
      if (!grid) return null;

      element.style.minHeight = '';
      return {
        selector:element,
        selectorHeight: element.offsetHeight,
        offsetTop: grid.offsetTop,
      }
    }).filter(item => item !== null);

    let offsets = gridOffsets.map(element => element.offsetTop);
    gridRowOffsets = [...new Set(offsets)];

    gridRowOffsets.forEach(rowOffset => {
      let rowGrids = gridOffsets.filter(grid => (grid.offsetTop == rowOffset));
      let comanElementHeight = Math.max.apply(Math,(rowGrids.map(ele => ele.selectorHeight)));
      rowGrids.forEach(grid => {
        grid.selector.style.minHeight = comanElementHeight+'px';
      });
    });
  }

  window.matchHeightCallback = () => {
    const selectors = [
      '.js-card-title',
      '.js-product-info',
      '.js-product-subtitle',
      '.js-product-dosage',
      '.js-blog-post-description',
      '.js-content-min-height',
      '.js-title-min-height'
    ];

    selectors.forEach(selector => {
      window.setGridHeight(selector);
    });
  };

  setTimeout(() => {
    window.matchHeightCallback();
  }, 2000)
  
  window.addEventListener('resize', function(event){
    window.matchHeightCallback();
  });

  window.matchHeightCallback();
}

{
  document.addEventListener('click', function (e) {
    const upgradeBtn = e.target instanceof HTMLElement
      ? e.target.closest('.js-loop-upgrade')
      : null;
      
    const upgradeItem = e.target instanceof HTMLElement
      ? e.target.closest('.js-upgrade-item')
      : null;
      

    if (!upgradeBtn || !upgradeItem) return;

    const productId = upgradeItem.getAttribute('product-id');
    const variantId = upgradeItem.getAttribute('variant-id');
    const quantity = upgradeItem.getAttribute('variant-quality');
    const lineKey = upgradeItem.getAttribute('data-line-key');
    const subscriptionCheck = upgradeItem.getAttribute('item-subsciption-check');

    const data = {
      product_id: productId,
      var_id: variantId,
      line_key: lineKey,
      quantity: quantity,
      subscription_check: subscriptionCheck
    };

    sessionStorage.setItem('loop_upgrade_pending', 'true');
    sessionStorage.setItem(
      'loop_upgrade_data',
      JSON.stringify(data)
    );
  });


  document.addEventListener('DOMContentLoaded', function () {
    const pendingUpgrade = sessionStorage.getItem('loop_upgrade_pending');
    if (pendingUpgrade !== 'true') return;

    const upgradeDataString = sessionStorage.getItem('loop_upgrade_data');
    if (upgradeDataString) {
      try {
        const upgradeData = JSON.parse(upgradeDataString);
        const productForm = document.querySelector('product-form-component.js-product-upgrade-form');
        const currentProductId = productForm ? productForm.getAttribute('data-product-id') : null;

        if (currentProductId && upgradeData.product_id === currentProductId && upgradeData.quantity) {
          const upgradeQty = upgradeData.quantity;
          
          customElements.whenDefined('quantity-selector-component').then(() => {
            const productQtySelector = /** @type {any} */ (document.querySelector('quantity-selector-component'));
            if (productQtySelector && typeof productQtySelector.setValue === 'function') {
               productQtySelector.setValue(upgradeQty);
               if (typeof productQtySelector.updateButtonStates === 'function') {
                 productQtySelector.updateButtonStates();
               }
            }
          });
          //  delete upgradeData[currentProductId];
          //  sessionStorage.setItem('loop_upgrade_data', JSON.stringify(upgradeData));
        }
      } catch (e) {
        console.error('Error parsing loop_upgrade_data', e);
      }
    }

    const checkExist = setInterval(() => {
      const options = document.querySelectorAll('.loop-widget-purchase-option');

      if (options.length >= 2) {
        const subscribeOption = [...options].find(
          el => el.getAttribute('aria-label') === 'Subscribe and save'
        );

        if (
          subscribeOption &&
          !subscribeOption.classList.contains('loop-widget-purchase-option-selected')
        ) {
          subscribeOption.click();
        }

        sessionStorage.removeItem('loop_upgrade_pending');
        clearInterval(checkExist);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(checkExist);
      sessionStorage.removeItem('loop_upgrade_pending');
    }, 3000);
  });
}

{
  setInterval(() => {
    document.querySelectorAll('.loop-widget-purchase-option').forEach(radio => {
      const updateUI = (option) => {
         const selectedOption = option.classList.contains('loop-widget-purchase-option-selected') ? option : option.closest('.loop-widget-purchase-option-selected');
         const label = document.querySelector('.loop-widget-purchase-options-label');

        if (label) {
          if (
            selectedOption &&
            selectedOption.hasAttribute('data-loop-widget-selling-plan-group')
          ) {
            label.innerHTML = `Purchase Options: <span>Subscribe & Save</span>`;
          } else {
            label.innerHTML = `Purchase Options: <span>One time purchase</span>`;
          }
        }
        
        const priceElement = option.querySelector('.loop-widget-purchase-option-price');
        const targetPriceElements = document.querySelectorAll('.js-sub-price-change');

        if (priceElement && targetPriceElements.length > 0) {
           const priceText = priceElement.textContent;
           targetPriceElements.forEach(target => {
             target.textContent = priceText;
           });
        }
      };

      if (radio.dataset.listenerAttached) return;
      radio.dataset.listenerAttached = 'true';

      radio.addEventListener('click', () => {
         setTimeout(() => updateUI(radio), 50);
      });

      if (radio.classList.contains('loop-widget-purchase-option-selected')) {
        updateUI(radio);
      }
    });
  }, 500);
}

{
  document.addEventListener('mouseover', function(e) {
    const target = e.target.closest('.js-menu-list-hover');
    if (!target) return;

    const title = target.getAttribute('data-js-menu-list-title');
    if (!title) return;

    const megaMenuGrid = target.closest('.js-mega-menu-grid');
    if (!megaMenuGrid) return;

    // Toggle active class on hover links
    const hoverLinks = megaMenuGrid.querySelectorAll('.js-menu-list-hover');
    hoverLinks.forEach(link => {
      if (link === target) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });

    const subLists = megaMenuGrid.querySelectorAll('.js-menu-sub-list');
    subLists.forEach(list => {
      const listTitle = list.getAttribute('data-js-menu-list-title');
      if (listTitle === title) {
        list.classList.remove('hidden');
      } else {
        list.classList.add('hidden');
      }
    });
  });
}

// read more functionality

{
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.read-more-btn');
    if (btn) {
      const wrapper = btn.closest('.read-more-wrapper');
      if (wrapper) {
        wrapper.classList.toggle('is-expanded');
        const isExpanded = wrapper.classList.contains('is-expanded');
        const textSpan = btn.querySelector('.read-more-text');
        if (textSpan) {
            textSpan.textContent = isExpanded ? 'Read Less' : 'Read More';
        }

        const teaser = wrapper.querySelector('.read-more-teaser');
        const full = wrapper.querySelector('.read-more-full');
        if (teaser && full) {
          teaser.style.display = isExpanded ? 'none' : 'block';
          full.style.display = isExpanded ? 'block' : 'none';
        }
      }
    }
  });
}

{
  const truncateHTML = (elem, limit) => {
    let count = 0;
    let isTruncated = false;
    
    const traverse = (node) => {
      if (count >= limit) {
        node.remove();
        isTruncated = true;
        return;
      }
      
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent;
        const regex = /[.!?](\s|$)/g;
        let match;
        
        while ((match = regex.exec(text)) !== null) {
          const index = match.index;
          const isDot = match[0].startsWith('.');
          
          if (isDot && index > 0) {
             const prevChar = text[index - 1];
             if (/[A-Z]/.test(prevChar)) {
                 if (index < 2 || /[^a-zA-Z]/.test(text[index - 2])) {
                     continue;
                 }
             }
          }

          count++;
          if (count >= limit) {
             const lastIndex = match.index + match[0].length;
             node.textContent = text.substring(0, lastIndex);
             if (lastIndex < text.length) {
                 isTruncated = true;
             } else {
                 isTruncated = true;
             }
             return; 
          }
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const children = Array.from(node.childNodes);
        for (const child of children) {
          traverse(child);
        }
      }
    };
    traverse(elem);
    return isTruncated;
  };

  const initTruncation = () => {
    document.querySelectorAll('.js-truncate-html').forEach(elem => {
      if (elem.dataset.truncated) return;
      const limit = parseInt(elem.dataset.sentenceLimit);
      if (limit > 0) {
        const isTruncated = truncateHTML(elem, limit);
        elem.dataset.truncated = 'true';
        
        if (!isTruncated) {
            const wrapper = elem.closest('.read-more-wrapper');
            if (wrapper) {
                wrapper.classList.add('no-truncation');
                const btn = wrapper.querySelector('.read-more-btn');
                if (btn) btn.style.display = 'none';
            }
        }
      }
    });
  };

  document.addEventListener('DOMContentLoaded', initTruncation);
  setInterval(initTruncation, 1000);
}

// Slider Arrows Triggers based on custom arrows setting
document.addEventListener('DOMContentLoaded', () => {
  const customArrowContainers = document.querySelectorAll('custom-slideshow-arrows');
  
  customArrowContainers.forEach(container => {
    const section = container.closest('.shopify-section');
    if (!section) return;

    /** @type {HTMLButtonElement | null} */
    const customPrev = container.querySelector('.slideshow-control--previous');
    /** @type {HTMLButtonElement | null} */
    const customNext = container.querySelector('.slideshow-control--next');
    
    // Find the hidden arrow with the same action within the section
    /** @type {HTMLButtonElement | null} */
    const targetPrev = section.querySelector('slideshow-arrows .slideshow-control--previous');
    /** @type {HTMLButtonElement | null} */
    const targetNext = section.querySelector('slideshow-arrows .slideshow-control--next');

    // Make sure we carry over disabled attribute state
    /**
     * @param {HTMLElement | null} target 
     * @param {HTMLElement | null} custom 
     */
    const syncDisabledState = (target, custom) => {
      if (!target || !custom) return;
      if (target.hasAttribute('disabled')) {
        custom.setAttribute('disabled', 'disabled');
      } else {
        custom.removeAttribute('disabled');
      }
    };

    // Initial sync on load
    syncDisabledState(targetPrev, customPrev);
    syncDisabledState(targetNext, customNext);

    // Bind proxy click events
    if (customPrev && targetPrev) {
      customPrev.addEventListener('click', function(e) {
        e.preventDefault();
        targetPrev.click();
      });
    }

    if (customNext && targetNext) {
      customNext.addEventListener('click', function(e) {
        e.preventDefault();
        targetNext.click();
      });
    }

    // Observer for Disabled state changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
           const target = /** @type {HTMLElement} */ (mutation.target);
           if (target === targetPrev) {
               syncDisabledState(targetPrev, customPrev);
           } else if (target === targetNext) {
               syncDisabledState(targetNext, customNext);
           }
        }
      });
    });

    if (targetPrev) observer.observe(targetPrev, { attributes: true, attributeFilter: ['disabled'] });
    if (targetNext) observer.observe(targetNext, { attributes: true, attributeFilter: ['disabled'] });
  });

  // Handle hiding custom arrows container entirely when 3 or fewer slides
  const updateArrowsVisibility = () => {
    document.querySelectorAll('slideshow-component.has-3-or-less-slides').forEach(component => {
       /** @type {HTMLElement | null} */
       const headerRight = component.querySelector('.carousel-header-right');
       if (headerRight) {
         if (window.innerWidth >= 1025) {
           headerRight.classList.add('hide-custom-arrows-on-desktop');
         } else {
           headerRight.classList.remove('hide-custom-arrows-on-desktop');
         }
       }
    });
  };

  updateArrowsVisibility();
  window.addEventListener('resize', updateArrowsVisibility);
});

// FAQ See More / See Less functionality
{
  const initFaqSeeMore = () => {
    document.querySelectorAll('.metafield-faq-inner[data-block-id]').forEach(accordion => {
      const seeMoreContainer = accordion.querySelector('.faq-see-more-container');
      const seeMoreLink = accordion.querySelector('.faq-see-more-link');
      const seeLessContainer = accordion.querySelector('.faq-see-less-container');
      const seeLessLink = accordion.querySelector('.faq-see-less-link');

      if (!seeMoreContainer || seeMoreContainer.dataset.initialized) return;
      seeMoreContainer.dataset.initialized = 'true';

      if (seeMoreLink) {
        seeMoreLink.addEventListener('click', (e) => {
          e.preventDefault();
          accordion.querySelectorAll('.faq-hidden-item').forEach(item => {
            /** @type {HTMLElement} */ (item).style.display = '';
          });
          seeMoreContainer.style.display = 'none';
          if (seeLessContainer) seeLessContainer.style.display = '';
        });
      }

      if (seeLessLink) {
        seeLessLink.addEventListener('click', (e) => {
          e.preventDefault();
          accordion.querySelectorAll('.faq-hidden-item').forEach(item => {
            /** @type {HTMLElement} */ (item).style.display = 'none';
          });
          if (seeLessContainer) seeLessContainer.style.display = 'none';
          seeMoreContainer.style.display = '';
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqSeeMore);
  } else {
    initFaqSeeMore();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initFaqSeeMore);
  }
}

// os js 
document.addEventListener('DOMContentLoaded', function () {
  var ua = navigator.userAgent.toLowerCase();
  var body = document.body;

  /* OS */
  if (/android/.test(ua)) body.classList.add('os-android');
  else if (/iphone|ipod/.test(ua)) body.classList.add('os-ios');
  else if (/ipad/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
    body.classList.add('os-ipados');
  else if (/windows/.test(ua)) body.classList.add('os-windows');
  else if (/mac os/.test(ua)) body.classList.add('os-macos');

  /* Browser */
  function addBrowser() {
    if (ua.indexOf('edg') > -1) body.classList.add('browser-edge');
    else if (ua.indexOf('opr') > -1 || ua.indexOf('opera') > -1) body.classList.add('browser-opera');
    else if (ua.indexOf('chrome') > -1) body.classList.add('browser-chrome');
    else if (ua.indexOf('firefox') > -1) body.classList.add('browser-firefox');
    else if (ua.indexOf('safari') > -1 && ua.indexOf('chrome') === -1)
      body.classList.add('browser-safari');
  }

  if (navigator.brave && navigator.brave.isBrave) {
    navigator.brave.isBrave().then(function (isBrave) {
      isBrave ? body.classList.add('browser-brave') : addBrowser();
    });
  } else {
    addBrowser();
  }
});

// enable_chat_on_click

{
  // Recursively searches all nested shadow roots for a selector
  const queryDeepShadow = (root, selector) => {
    const found = root.querySelector(selector);
    if (found) return found;

    const all = root.querySelectorAll('*');
    for (const el of all) {
      if (el.shadowRoot) {
        const result = queryDeepShadow(el.shadowRoot, selector);
        if (result) return result;
      }
    }
    return null;
  };

  setInterval(() => {
    document.querySelectorAll('.ai-chat-trigger').forEach(trigger => {
      if (trigger.dataset.listenerAttached) return;
      trigger.dataset.listenerAttached = 'true';

      trigger.addEventListener('click', () => {
        // Path: molin-bubble → #shadow-root → molin-shop-ai → #shadow-root → .shadow-button
        const molinBubble = document.querySelector('molin-bubble');
        if (molinBubble && molinBubble.shadowRoot) {
          const molinShopAi = molinBubble.shadowRoot.querySelector('molin-shop-ai');
          if (molinShopAi && molinShopAi.shadowRoot) {
            const btn = molinShopAi.shadowRoot.querySelector('.shadow-button');
            if (btn instanceof HTMLElement) {
              btn.click();
              return;
            }
          }

          // Fallback: deep shadow search from molin-bubble's shadow root
          const deepBtn = queryDeepShadow(molinBubble.shadowRoot, '.shadow-button');
          if (deepBtn instanceof HTMLElement) {
            deepBtn.click();
            return;
          }
        }

        // Last resort: full document deep shadow search
        const globalBtn = queryDeepShadow(document, '.shadow-button');
        if (globalBtn instanceof HTMLElement) {
          globalBtn.click();
          return;
        }

        // JS API fallback
        if (window.MoilinChat && typeof window.MoilinChat.open === 'function') {
          window.MoilinChat.open();
        }
      });

      trigger.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        trigger.click();
      });
    });
  }, 500);
}

/**
 * Subscription Agreement logic for Checkout
 */
{
  const handleSubscriptionAgreement = () => {
    const cartContainers = document.querySelectorAll('.cart__ctas');

    cartContainers.forEach(container => {
      const agreementCheckbox = container.querySelector('[name="subscription-confirmation"]');
      const checkoutButton = container.querySelector('[name="checkout"]');
      const additionalButtons = container.querySelector('.js-additional-checkout-buttons');

      if (!agreementCheckbox || !checkoutButton) return;

      const updateUI = () => {
        const isChecked = agreementCheckbox.checked;
        checkoutButton.disabled = !isChecked;
        
        if (additionalButtons) {
          if (isChecked) {
            additionalButtons.classList.remove('additional-checkout-buttons--subscription-hidden');
          } else {
            additionalButtons.classList.add('additional-checkout-buttons--subscription-hidden');
          }
        }
      };

      // Remove existing listener to avoid duplicates if re-initialized
      agreementCheckbox.removeEventListener('change', updateUI);
      agreementCheckbox.addEventListener('change', updateUI);
      updateUI(); // Initial check
    });
  };

  // Initialize on load
  document.addEventListener('DOMContentLoaded', handleSubscriptionAgreement);

  // Re-initialize on cart updates (for AJAX cart)
  document.addEventListener('cart:update', () => {
    setTimeout(handleSubscriptionAgreement, 100);
  });
}

//  loop subscription wigdet price change dynamically 
{
  document.addEventListener('variant:update', function(event) {
    const variant = event.detail?.resource;
    if (!variant) return;

    const formatPrice = (amount) => {
      const price = document.querySelector('.loop-widget-purchase-option-price');
      const symbol = price ? price.textContent.replace(/[0-9.,]/g, '').trim() : '£';
      return symbol + (amount / 100).toFixed(2);
    };

    const oneTimePrice = document.querySelector('[data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price');
    if (oneTimePrice && variant.price !== undefined) {
      oneTimePrice.textContent = formatPrice(variant.price);
    }

    const subscriptionOptions = document.querySelectorAll('[data-loop-widget-selling-plan-group]');
    subscriptionOptions.forEach(option => {
      const groupId = option.getAttribute('data-selling-plan-group-id');
      const price = option.querySelector('.loop-widget-purchase-option-price');
      
      if (groupId && price && variant.selling_plan_allocations) {
        const allocation = variant.selling_plan_allocations.find(
          (allocation) => allocation.selling_plan_group_id === groupId
        );
        if (allocation && allocation.price !== undefined) {
          price.textContent = formatPrice(allocation.price);
        }
      }
    });

    const selectedOption = document.querySelector('.loop-widget-purchase-option-selected');
    if (selectedOption) {
      const priceElement = selectedOption.querySelector('.loop-widget-purchase-option-price');
      const targetPriceElements = document.querySelectorAll('.js-sub-price-change');
      if (priceElement && targetPriceElements.length > 0) {
        const priceText = priceElement.textContent;
        targetPriceElements.forEach(target => {
          target.textContent = priceText;
        });
      }
    }
  });
}